{
	"it": {
		"service_not_available": "Servizio non disponibile",
		"service_not_available_explain": "Ci dispiace, il servizio non è al momento disponibile",
		"business_owner_contact": "Se sei il proprietario dell'attività, clicca qui:",
		"login": "Accedi"
	},
	"en": {
		"service_not_available": "Service not available",
		"service_not_available_explain": "We're sorry, the service is currently unavailable",
		"business_owner_contact": "If you are the business owner, click here:",
		"login": "Login"
	}
}